document.addEventListener("DOMContentLoaded", function () {
	const splideElem = document.querySelector(".mm-recettes-splide");
	const progressBar = splideElem.querySelector(".mm-splide-progress-bar");

	if (!splideElem) {
		return;
	}

	const splideRecettes = new Splide(splideElem, {
		type: "slide",
		arrows: true,
		pagination: false,
		autoWidth: true,
		focus: 0,
		omitEnd: true,
		gap: 32,
		breakpoints: {
			768: {
				gap: 12,
			},
		},
	});

	// Met à jour la barre de progression
	splideRecettes.on("mounted move", function () {
		let end = splideRecettes.Components.Controller.getEnd() + 1;
		let rate = Math.min((splideRecettes.index + 1) / end, 1);
		progressBar.style.width = String(100 * rate) + "%";
	});

	splideRecettes.mount();
});
